import React from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";
import { Twitter, Linkedin, Github, Mail } from "lucide-react";
import { FOOTER_COLS, SOCIAL_LINKS, BRAND } from "@/config/site.config";

const ICONS = [
  { Icon: Twitter, href: SOCIAL_LINKS.twitter, label: "Twitter" },
  { Icon: Linkedin, href: SOCIAL_LINKS.linkedin, label: "LinkedIn" },
  { Icon: Github, href: SOCIAL_LINKS.github, label: "GitHub" },
  { Icon: Mail, href: SOCIAL_LINKS.email, label: "Email" },
];

export default function Footer() {
  return (
    <footer className="container-px pb-16 pt-20" data-testid="site-footer">
      <div className="mx-auto max-w-7xl">
        <div className="divider-gold mb-16" />
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <Logo />
            <p className="mt-5 text-white/55 text-sm leading-relaxed max-w-sm">
              {BRAND.tagline}. {BRAND.name} crafts queue systems, AI agents, custom software
              and digital infrastructure for premium businesses worldwide.
            </p>
            <div className="mt-6 flex items-center gap-3">
              {ICONS.map(({ Icon, href, label }, i) => (
                <a
                  key={i}
                  href={href}
                  target={href.startsWith("http") ? "_blank" : undefined}
                  rel={href.startsWith("http") ? "noopener noreferrer" : undefined}
                  className="h-9 w-9 rounded-full border border-white/10 flex items-center justify-center text-white/60 hover:text-gold-300 hover:border-gold-500/40 transition-colors"
                  aria-label={label}
                  data-testid={`footer-social-${i}`}
                >
                  <Icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>

          {FOOTER_COLS.map((c) => (
            <div key={c.title} className="md:col-span-2">
              <div className="eyebrow mb-4">{c.title}</div>
              <ul className="space-y-3">
                {c.items.map((it) => (
                  <li key={it.label}>
                    <Link to={it.to} className="text-sm text-white/70 hover:text-gold-300 transition-colors">
                      {it.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-16 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-white/40">
          <div>© {new Date().getFullYear()} {BRAND.name}. All rights reserved.</div>
          <div className="font-mono uppercase tracking-[0.2em]">Crafted with Precision</div>
        </div>
      </div>
    </footer>
  );
}
